import type { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { observer } from 'mobx-react-lite'
import { getLang, nextCommonProps } from '@/utils/index'
import { getHeaderConfig } from 'server/config'
import getBaseProps from 'server/getBaseProps'
import PriceLayout from '@/components/PriceLayout'
import { HOME_PAGE_URL } from '@/constants/index'

const Home = () => {
  return <PriceLayout />
}

export const getServerSideProps: GetServerSideProps = async props => {
  const { locale, req, res, query } = props
  const i18nsJson = await serverSideTranslations(getLang(locale), ['header', 'footer', 'price', 'fundraising'])

  const config = await getHeaderConfig(props)

  return {
    props: {
      /**引入多语言属性,可根据当前页面需要的翻译文件注入 */
      ...i18nsJson,
      /**组装公用的props属性 */
      ...nextCommonProps({ req, res, query, locale }),
      ...config,
      ...(await getBaseProps(props, { pageType: HOME_PAGE_URL.Others })),
      tdkTitle: 'Market',
    },
  }
}

export default observer(Home)
